import { render } from "./CommunityView.vue?vue&type=template&id=a92860b8&ts=true"
import script from "./CommunityView.vue?vue&type=script&lang=ts"
export * from "./CommunityView.vue?vue&type=script&lang=ts"

import exportComponent from "/var/www/admin.beepi.cl/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__